// extracted by mini-css-extract-plugin
export default {"personBox":"lBr9JSKanxcRKy8BG0pf","shake":"UST6DcuXTaw38okxQKWA"};